<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="loading"
    :items="items"
    :items-length="totalItems"
    class="elevation-2"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Helpdesk Issues</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search By Summary"
            single-line
            hide-details
            @input="searchTable()"
          />

          <v-spacer />

          <!--  -->
        </v-toolbar>
      </v-card-title>
    </template>
  </v-data-table-server>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';

export default {
  name: 'Helpdesk',

  mixins: [dataTableMixin],

  data() {
    return {
      headers: [
        { text: 'Key', value: 'key', width: '15%' },
        { text: 'Summary', value: 'summary', width: '35%' },
        { text: 'Status', value: 'status', width: '20%' },
        { text: 'Description', value: 'description', width: '30%' },
      ],
    };
  },

  methods: {
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/helpdesk', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data?.data?.data || [];
          this.totalItems = res.data?.data?.total || 0;
        })
        .catch((error) => {
          this.loading = false;
          console.error('Error fetching helpdesk data:', error);
        });
    },
  },
};
</script>

<style scoped></style>
